// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-setting-container .api-gateway-nav-borderless {\n  border: none;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/AppSetting/Components/ApiGateway/ApiGatewayNav/ApiGatewayNav.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd","sourcesContent":[".app-setting-container .api-gateway-nav-borderless {\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
